

import './NavbarStyle.css';
import { //Button, 
		Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React from 'react';


// const AuthNavMenu = () => (
// 	<Nav className="flex-row mb-2 mb-lg-0 ms-lg-3">
// 		<Nav.Item className="me-2">
// 			<Button variant="outline-primary" className="px-3">
// 				Sign Up
// 			</Button>
// 		</Nav.Item>
// 		<Nav.Item>
// 			<Button variant="primary" className="px-3">
// 				Log In
// 			</Button>
// 		</Nav.Item>
// 	</Nav>
// );

const Navigation2 = () => {
	// const [isOpen, setIsOpen] = useState(false);
	const location = useLocation();
	const navigate = useNavigate(); 


	const scrollToSection = (id) => {
		const element = document.getElementById(id);
		if (element) {
		element.scrollIntoView({ behavior: 'smooth' });
		}
		// setIsOpen(false);
	};

	const handleNavigation = (id) => {
		if (location.pathname === '/') {
		scrollToSection(id);
		} else {
			navigate('/', { state: { targetId: id } }); 
		}
	};
	return (
		<div className="ezy__nav2 dark">
			<Navbar expand="lg" className="py-3">
				<Container>
					<Link to={`/`} style={{ textDecoration: 'none' }}>
						<Navbar.Brand>SCHOLARIZE</Navbar.Brand>
					</Link>
					<Navbar.Toggle aria-controls="ezy__nav2-navbar-nav">
						<span>
							<span />
						</span>
					</Navbar.Toggle>
					<Navbar.Collapse id="ezy__nav2-navbar-nav">
					<Nav className="ms-auto mb-2 mb-lg-0 mt-4 mt-lg-0">
					
					
			        	<Nav.Link onClick={() => handleNavigation('contactus')}>تماس با ما</Nav.Link>
		            	{/* <Nav.Link onClick={() => navigate('/Services')}>پکیج‌ها</Nav.Link> */}
		        	    <Nav.Link onClick={() => navigate('/posts')}>پست‌ها</Nav.Link>
		    	        <Nav.Link onClick={() => navigate('/Services')}>خدمات</Nav.Link>
			            <Nav.Link onClick={() => navigate('/')}>خانه</Nav.Link>
					
	  				</Nav>
						{/* <AuthNavMenu /> */}
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</div>
	);
};


export default Navigation2;